"use client";

import { useTranslations } from "next-intl";
import { useConsumerLocale } from "@/app/i18n/ConsumerIntlProvider";
import { TermsPageView } from "@/components/terms/TermsPageView";
import type { ParsedTerms } from "@/content/parseConsumerTerms";

/**
 * Renders account-deletion guidance with locale-aware chrome.
 */
export function AccountDeletionPageClient({ data }: { data: ParsedTerms }) {
  const t = useTranslations("accountDeletion");
  const { locale } = useConsumerLocale();
  return (
    <TermsPageView
      title={t("title")}
      subtitle={t("subtitle")}
      backLabel={t("backToEvents")}
      languageNote={locale === "en" ? t("languageNote") : null}
      introParagraphs={data.introParagraphs}
      sections={data.sections}
    />
  );
}
